import React from "react";
import Loading from "../common/Loading";
import OverlayPopup from "../map/OverlayPopup";
import { FormattedNumber, FormattedDate } from "react-intl";
import publicApi from "../../api/public-api";
import Fa from "../common/Fa";

/**
 * Corresponde al overly que contiene la información de la parcela que es resultado
 * de la busqeueda.
 */
export default class InfoCuenta extends OverlayPopup {
  state = {
    loading: true,
    error: false
  };

  overlay = React.createRef();
  coordinate = null;
  filter = null;

  close() {
    this.setState({ loading: true, error: false, padron: undefined });
    super.close();
  }

  data(data) {
    this.filter = data;
    this.setState({ loading: true, error: false, padron: undefined });
    return publicApi
      .cuentas(data)
      .then(response => {
        //console.log(response);
        let data = response.data;
        data.loading = false;
        data.error = false;
        this.setState(data);
      })
      .catch(error => {
        console.error(error);
        this.setState({ loading: false, error: true });
      });
  }
  /**
   * Se encarga de renderizar el contenido del ovelay
   */
  renderContent() {
    if (this.state.loading) {
      return <Loading />;
    } else if (!this.state.loading && this.state.error) {
      return "Error";
    } else if (!this.state.loading && this.state.padron) {
      return this.renderRural();
    } else if (!this.state.loading && !this.state.padron) {
      return this.renderUrbano();
    }
  }
  /**
   *
   */
  renderInfo(padron) {
    let path = padron
      ? "#!/consulta-publica/cuentas-rurales"
      : "#!/consulta-publica/cuentas-corrientes";
    return (
      <small className="help">
        <hr />
        <Fa icon="info-circle" />
        Las iformación correspondiente a los registros del SNC.&nbsp;
        <u>
          <a
            target="_blank"
            href={`https://www.catastro.gov.py/servicio-linea/${path}`}
          >
            <Fa icon="external-link-alt" />
            Más Iformación.
          </a>
        </u>
      </small>
    );
  }
  /**
   * Renderiza una cuenta rural
   */
  renderRural() {
    return (
      <div>
        <h3>Datos del Padrón</h3>
        <ul className="dl-horizontal">
          <li>Departamento: {this.state.departamento}</li>
          <li>Distrito: {this.state.distrito}</li>
          <li>Padrón: {this.state.padron}</li>
          <li>Finca: {this.state.finca}</li>
          <li>
            Fecha Inscripción:
            <FormattedDate
              value={new Date(this.state.fechaInscripcion)}
              format="short"
            />
          </li>
          <li>Situación: {this.statesituacion}</li>
          <li>
            Hectáreas: <FormattedNumber value={this.state.hectareas} /> Ha.
          </li>
          <li>
            Metros Cuadrados:{" "}
            <FormattedNumber value={this.state.metrosCuadrados} /> m<sup>2</sup>
          </li>
          <li>
            Valor Oficial: <FormattedNumber value={this.state.valorOficial} />{" "}
            {"Gs."}
          </li>
        </ul>
        {this.renderInfo(true)}
      </div>
    );
  }
  /**
   * Renderiza una cuenta corriente
   */
  renderUrbano() {
    return (
      <div>
        <h3>Datos de la cuenta corriente</h3>
        <ul className="dl-horizontal">
          <li>Departamento: {this.state.departamento}</li>
          <li>Distrito: {this.state.distrito}</li>
          <li>Zona: {this.state.zona}</li>
          <li>Manzana: {this.state.manzana}</li>
          <li>Lote: {this.state.lote}</li>
          <li>Finca: {this.state.finca}</li>
          <li>Loteo Manzana: {this.state.loteoManzana}</li>
          <li>Loteo Lote: {this.state.loteoLote}</li>
          <li>
            Fecha Actualización:
            <FormattedDate
              value={new Date(this.state.fechaInscripcion)}
              format="short"
            />
          </li>
          <li>Situación: {this.state.situacion}</li>
          <li>
            Superficie M2: <FormattedNumber value={this.state.superficieM2} /> m
            <sup>2</sup>
          </li>
          <li>
            Superficie Edificada M2:{" "}
            <FormattedNumber value={this.state.supeficieEdificadaM2} /> m
            <sup>2</sup>
          </li>
          <li>
            Valor Tierra: <FormattedNumber value={this.state.valorTierra} /> Gs.
          </li>
          <li>
            Valor Edificación:{" "}
            <FormattedNumber value={this.state.valorEdificacion} /> Gs.
          </li>
        </ul>
        {this.renderInfo(false)}
      </div>
    );
  }
}
